/**
 *  分模块翻译，方便维护
 *  lang/zh-cn/module/common.js
 */

export default {
  "common": {
    "lang": "语言",
    "chinese": "中文",
    "english": "英文",

    "model_list": "型号列表",
    "start": "初始",
    "lead": "联系",
    "approved": "交付",
    "done": "完成",
    "spu": "型号",
    "brand": "厂牌",
    "category": "类目",
    "date_code": "批次",
    "lead_time": "货期",
    "packing": "包装",
    "coo": "产地",
    "qty": "数量",
    "price": "价格",
    "shop": "商户",
    "member": "成员",
    "created": "创建",
    "updated": "更新",
    "type": "类型",
    "status": "状态",
    "remark": "备注",
    "description": "描述",
    "warehouse": "仓库",
    "tags": "标签",
    "tax_categ": "税种",

    "latest":"最新",
    "frequency":"频次",

    "rfq_qty": "询价数",
    "buy_qty": "买入数",
    "avab_qty": "供货数",
    "sell_qty": "卖出数",
    "trade_qty": "成交数",
    "tx_amount": "成交额",

    "title": "标题",
    "column": "栏目",
    "column_layout": "栏目布局",
    "column_manager": "栏目经理",
    "fixed_column": "固定栏目",
    "author": "作者",
    "date": "日期",
    "read": "阅读",
    "like": "点赞",
    "favorite": "收藏",
    "comment": "评论",
    "share": "分享",
    "article_list": "文章列表",
    "view_more": "查看更多",
    "eccn_number": "ECCN号",
  },
  "tip": {
    "search": "请输入关键词搜索",
    "select": "请选择",
    "please_enter": "请输入",
    "column_search": "查询栏目信息失败！",
    "no_editable": "（注：发布稿公开后将不允许编辑）",
    "positive_integers": "计划邀请数须为大于0的整数",
    "allowed_upload": "上传图片只能是 JPG、GIF、BMP、PNG、TIF、RAW 格式!",
    "image_size": "上传图片大小不能超过 20MB!",
    "single_image": "只能上传一张图片",
    "spu_not_matched": "型号未能匹配产品库，产品经理处理中，产品经理处理完成才展示匹配信息",
    "aliases": "请输入别名，多个用竖线“|”隔开",
    "former": "请输入曾用名，多个用竖线“|”隔开",
    "catalog_price": "确认当前目录价吗？",
  },
  "validate": {
    "user": "请输入手机/邮箱/用户名",
    "password": "请输入密码",
    "phone_number": "请输入手机号码",
    "correct_phone": "请输入正确的手机号",
    "code": "请输入验证码",
    "captcha": "请输入图形验证码",
    "user_name": "请输入用户名",
    "user_rule": "请输入6-20位字母、数字或符号",
  },
  "button": {
    "search": '查',
    // portal/sku
    "disk_allocation": '配盘',
    "inquiry": '询价',
    "supply": '供货',
    "sale": '销售',
    "purchase": '采购',
    "clear": '清空',

    "create": '创建',
    "edit": '编辑',
    "delete": '删除',
    "view": '查看',
    "copy": '复制',
    "paste": '粘贴',
    "download": '下载',
    "upload": '上传',
    "export": '导出',
    "import": '导入',
    "print": '打印',
    "save": '保存',
    "cancel": '取消',
    "confirm": '确认',
    "submit": '提交',
    "reset": '重置',
    "assign": '分派',
    "approved": "通过",
    "rejected": "驳回",
    "review": "审核",
    "active": "激活",
    "archive": "归档",
    "apply": "申请",
    "approval": "批准",
  }
};
